import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { ExamTypeCategory } from "../examTypeCategory/type";

export default function ExamTypeCategoryDetailButton(
  props: GridCellParams<ExamTypeCategory, any>
) {
  return (
    <Link component={RouterLink} to={props.row.categoryCode}>
      Detay
    </Link>
  );
}
